export const CustomerType = {
  NORMAL: "Normal",
  DEMO: "Demo",
};
